(() => {
  if (customElements.get("hero-slideshow")) {
    return;
  }

  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.swiper = new Swiper(this, {
        pagination: {
          el: this.querySelector("[data-pagination]"),
          clickable: true
        },
        ...(this.dataset.autoplay === "true" && {
          autoplay: {
            delay: Number(this.dataset.autoplayDelay),
            disableOnInteraction: false
          },
        }),
      });

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => {
          this.swiper.slideToLoop(Number(e.target.dataset.id));
        });
      }
    }
  }

  customElements.define("hero-slideshow", HeroSlideshow);
})();
